import React from 'react';
import { BookOpenIcon, CheckIcon } from 'lucide-react';
import { deliverables } from '../data/copy';
export function Deliverables() {
  const featured = deliverables.find(item => item.featured);
  const rest = deliverables.filter(item => !item.featured);
  return <section aria-labelledby="incluye" className="w-full bg-cream" data-id="element-33" data-mp="1e3kdkpf4t1cw">
      <div className="mx-auto w-full max-w-5xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-34" data-mp="199g5g2u4qna8">
        <h2 id="incluye" className="font-display text-[1.6rem] font-bold leading-tight text-ink sm:text-3xl lg:text-[2.5rem]" data-id="element-35" data-mp="1nym33mdbk5g0">
          Lo que recibes hoy mismo
        </h2>
        <p className="mt-2 max-w-xl text-[1rem] text-muted sm:mt-3 sm:text-lg" data-id="element-36" data-mp="1x02453i8uv7k">
          Todo el sistema completo, descargable al instante después de tu pago.
        </p>

        {featured && <article className="mt-6 flex gap-4 rounded-xl bg-navy p-5 text-white shadow-card sm:mt-10 sm:items-start sm:gap-5 sm:p-10" data-id="element-37" data-mp="2n2v5t8dcz99">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gold sm:h-12 sm:w-12" aria-hidden="true" data-id="element-38" data-mp="3uspye7qk5zno">
              <BookOpenIcon className="h-5 w-5 text-navy-deep sm:h-6 sm:w-6" data-id="element-39" data-mp="3p4ghs6ojl3jt" />
            </span>
            <div data-id="element-40" data-mp="3u1yv099le4xm">
              <h3 className="font-display text-lg font-bold leading-snug sm:text-2xl" data-id="element-41" data-mp="3u1gmoe9no09c">
                {featured.title}
              </h3>
              <p className="mt-1.5 text-[0.95rem] leading-relaxed text-white/75 sm:mt-2 sm:text-base" data-id="element-42" data-mp="7ogpqbi2p268">
                {featured.text}
              </p>
            </div>
          </article>}

        <div className="mt-3 grid gap-3 sm:mt-6 sm:grid-cols-2 sm:gap-6" data-id="element-43" data-mp="go3vtalqyw5m">
          {rest.map(item => <article key={item.title} className="flex h-full gap-3 rounded-xl border border-sand bg-white p-4 shadow-card sm:flex-col sm:gap-0 sm:p-6" data-id="element-44" data-mp="lmf5nlc1l6nu">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gold/15 sm:mb-4 sm:h-8 sm:w-8" aria-hidden="true" data-id="element-45" data-mp="2nfw9edx1xndb">
                <CheckIcon className="h-3.5 w-3.5 text-gold-dark sm:h-4 sm:w-4" strokeWidth={3} data-id="element-46" data-mp="2bdbsze9nt8ai" />
              </span>
              <div data-id="element-47" data-mp="2pd4d2qqokq9i">
                <h3 className="text-base font-semibold leading-snug text-ink sm:text-lg" data-id="element-48" data-mp="2pdmfy67um2qe">
                  {item.title}
                </h3>
                <p className="mt-1 text-[0.9rem] leading-relaxed text-muted sm:mt-2 sm:text-base" data-id="element-49" data-mp="2ychovq2a1qxe">
                  {item.text}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}